import { PaymentStatusTag } from '../enrollment';

export const orderFields = [{
  label: 'Status',
  name: 'status',
  component: PaymentStatusTag
}]
